import React from 'react'
import styled from 'styled-components'
import Button from '../ui/button'
import ProgressIndicator from './progress-indicator'
import { PHONELG, TABLET, LAPTOP } from '../../utilities/breakpoints'
import TableColumnLabel from '../ui/table-column-label'
import { getThemeStyle } from '../../utilities/helpers'
import DriverStatBar from '../ui/driver-stat-bar'
import DriverProgressCard from './driver-progress-card'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { sortingService } from '../../utilities/sortingService'

const mapStateToProps = ({ survey: { prSortingType, sortAscending } }) => {
  return {
    prSortingType,
    sortAscending,
  };
};

const ThemeProgressCard= ({
  theme,
  themeIndex = 0,
  useTranslate,
  themeBaseURL,
  prSortingType,
  sortAscending
}) => {

  const sortedDrivers = [...theme.drivers];
  const sortingFunction = sortingService.getSortingFunction(prSortingType);
  sortedDrivers.sort(sortingFunction(sortAscending));

  return (
    <ThemeCard>
      <Header style={{ backgroundColor: getThemeStyle(themeIndex).bgColor }}>
        <h4>{theme.title}</h4>
        <Button
          as={Link}
          to={`${themeBaseURL}/${theme.id}`}
          className={"more-details-btn"}
          size={"sm"}
          kind={"gray"}
          addArrow={true}
        >
          {useTranslate("data_vault.more_details")}
        </Button>
      </Header>
      <ResultContainer>
        <ResultColumns className={"labels"}>
          <TableColumnLabel>{useTranslate("progress_reports.label_progress")}</TableColumnLabel>
          <TableColumnLabel>{useTranslate("progress_reports.label_latest")}</TableColumnLabel>
          <TableColumnLabel>{useTranslate("progress_reports.label_previous")}</TableColumnLabel>
        </ResultColumns>
        <ResultColumns className={"results"}>
          <ResultColumn>
            <TableColumnLabel>{useTranslate("progress_reports.label_progress")}</TableColumnLabel>
            <ProgressIndicator
              resultProgress={theme.resultProgressSincePrevious}
              showRating={false}
              size={"lg"}
            />
          </ResultColumn>
          <ResultColumn>
            <TableColumnLabel>{useTranslate("progress_reports.label_latest")}</TableColumnLabel>
            <DriverStatBar
              result={theme.results[0].result ? theme.results[0].result : null}
              useTranslate={useTranslate}
              barColor={getThemeStyle(themeIndex).bgColor}
            />
          </ResultColumn>
          <ResultColumn style={{opacity: "0.5"}}>
            <TableColumnLabel>{useTranslate("progress_reports.label_previous")}</TableColumnLabel>
            <DriverStatBar
              result={theme.results[1].result ? theme.results[1].result : null}
              useTranslate={useTranslate}
              barColor={getThemeStyle(themeIndex).bgColor}
            />
          </ResultColumn>
        </ResultColumns>
      </ResultContainer>
      <DriversContainer>
        {sortedDrivers.map((driver, index) => {
          return (
            <DriverProgressCard
              key={index}
              index={index}
              driver={driver}
              useTranslate={useTranslate}
              showLabels={index < 1}
              showPrevious={false}
              progressSize={"md"}
            />
          )
        })}
      </DriversContainer>
    </ThemeCard>
  )
}

export default connect(mapStateToProps)(ThemeProgressCard);

const ThemeCard = styled.div`
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.06);
  
  & + & {
    margin-top: 1rem;
  }
`;

const Header = styled.div`
  border-radius: 10px 10px 0 0;
  padding: 20px 15px;
  color: #fff;

  gap: 20px;
  
  .engager-btn {
    width: auto;
    margin-top: 20px;
  }
  
  h4 {
    margin: 0;
  }
  
  @media${TABLET} {
    padding: 30px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    
    .engager-btn {
      margin-top: 0;
    }
  }
  
  @media${LAPTOP} {
    padding: 40px 40px;
  }
`;

const ResultContainer = styled.div`
  padding: 20px 15px;
  
  @media${TABLET} {
    padding: 20px 20px 30px;
  }
  
  @media${LAPTOP} {
    padding: 25px 40px 30px;
  }
`;

const DriversContainer = styled.div`
  border-top: 1px solid #d9d9d9;
  padding: 20px 15px;
  
  @media${TABLET} {
    padding: 20px 20px;
  }
  
  @media${LAPTOP} {
    padding: 25px 40px;
  }
`;

const ResultColumns = styled.div`
  &.labels {
    display: none;
  }
  
  @media${PHONELG} {
    display: grid;
    grid-template-columns: 110px 1fr 1fr;
    grid-column-gap: 10px;
    align-items: center;
    
    &.labels {
      display: grid;
      margin-bottom: 8px;
    }
  
  }
  
  @media${TABLET} {
    grid-column-gap: 30px;
  }
`;

const ResultColumn = styled.div`
  margin-bottom: 10px;
  
  .table-column-label {
    margin-bottom: 5px;
  }
  
  @media${PHONELG} {
    margin-bottom: 0;
    
    .table-column-label {
      display: none;
    }
  }
`;


// WEBPACK FOOTER //
// ./src/components/progress-reports/theme-progress-card.js